module.exports = __webpack_public_path__ + "img/before-event.b0510b91.png";